import React, { useEffect, useRef, FC } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { styled } from '@mui/material/styles';

// Opcional: Estilizar o Step para garantir que não quebre linha
const CustomStep = styled(Step)({
    minWidth: '120px', // Ajuste conforme o conteúdo
});

// 1. Definindo a interface para as props do componente
interface HorizontalStepperProps {
    activeStep: number;
    steps: string[];
}

const HorizontalStepperWithScroll: FC<HorizontalStepperProps> = ({ activeStep, steps }) => {
    // 2. Tipando a ref para ser um array de elementos HTML (ou nulos)
    const stepRefs = useRef<(HTMLDivElement | null)[]>([]);

    useEffect(() => {
        const activeStepNode = stepRefs.current[activeStep];
        
        if (activeStepNode) {
            activeStepNode.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
    }, [activeStep]);

    return (
        <Box
            sx={{
                width: '100%',
                overflowX: 'auto',
                '&::-webkit-scrollbar': { display: 'none' },
                scrollbarWidth: 'none',
            }}
        >
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label, index) => (
                    // A ref aqui dentro já infere o tipo correto (HTMLDivElement | null)
                    <CustomStep key={label} ref={el => (stepRefs.current[index] = el)}>
                        <StepLabel>{label}</StepLabel>
                    </CustomStep>
                ))}
            </Stepper>
        </Box>
    );
};

export default HorizontalStepperWithScroll;